import React from 'react';

import Testimonial from './Testimonial';

export default function SectionTestimonial({ section }) {
  const { references } = section;
  return <Testimonial testimonial={references[0]} isLarge />;
}
